import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApproveSale from './ApproveSale';
import { approveSale, toggleSaleAction, preApproveSale } from '../../../actions/sales_actions';

function mapStateToProps(state) {
  return {
    open: state.sales[`actionApprove-SaleOpen`],
    openPre: state.sales[`actionPreApprove-SaleOpen`],
    requestSend: state.requestState[`requestApprove-SaleSend`]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    approveSale: bindActionCreators(approveSale, dispatch),
    preApproveSale: bindActionCreators(preApproveSale, dispatch),
    toggleSaleAction: bindActionCreators(toggleSaleAction, dispatch)
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApproveSale);
